import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('partner')
export const getOperatorCounts = ({ operatorId, count }: any) => {
    return axiosInstance.post(`/operator-assignment/assign-by-operatorId/${operatorId}/${count}`)
}
export const getOperatorPrint =({operatorId}:any)=>{
    return axiosInstance.post(`/operator-assignment/assign-by-operatorId/${operatorId} `)
}

export const operatorAssigmentItemIssue=(orderId:string|number)=>{
    return axiosInstance.post(`/operator-assignment/assign-order-problem/${orderId}`)
}